var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 37C21.8638 37 24.2044 36.5344 26.3883 35.6298C28.5722 34.7253 30.5565 33.3994 32.2279 31.7279C33.8994 30.0565 35.2253 28.0722 36.1298 25.8883C37.0344 23.7044 37.5 21.3638 37.5 19C37.5 16.6362 37.0344 14.2956 36.1298 12.1117C35.2253 9.92784 33.8994 7.94353 32.2279 6.27208C30.5565 4.60062 28.5722 3.27475 26.3883 2.37017C24.2044 1.46558 21.8638 1 19.5 1C14.7261 1 10.1477 2.89642 6.77208 6.27208C3.39642 9.64773 1.5 14.2261 1.5 19C1.5 23.7739 3.39642 28.3523 6.77208 31.7279C10.1477 35.1036 14.7261 37 19.5 37Z",
    fill: "white",
    stroke: "#939599",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19L17.5 23L25.5 15",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19L17.5 23L25.5 15",
    stroke: "#939599",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/not-verified.e0874ea1c651a7d940e0c9da3f3a311b.svg";
export { ForwardRef as ReactComponent };